(async () => {
  const baseComponent = await import(window.theme.modules.baseComponent);

  customElements.define('main-header', class extends baseComponent.default {
    elements = {
      logo: '[data-logo]',
      nav: 'main-nav'
    };
    
    render() {
      this.setOverlap();
      this.on('stickyMainHeader', (e, { sticky }) => {
         var headerInner = document.querySelector(".main-header-inner-container");
         var headerInnerHeight = headerInner.offsetHeight;
         const collectionList = document.querySelector(".collection__list-main");

        if(sticky) {
          this.classList.add('@sticky');
          document.body.style.setProperty('--sticky-header-offset', `${this.$nav.offsetHeight}px`);
          document.body.classList.add("sticky_collection-list");
          if (collectionList) {
            collectionList.style.top = headerInnerHeight + "px";
          }
        } else {
          this.classList.remove('@sticky');
          document.body.classList.remove("sticky_collection-list");
          if (collectionList) {
            collectionList.style.top = "0px";
          }
          document.body.style.setProperty('--sticky-header-offset', '0');
        }
      })
    };

    setOverlap() {
      this.style.setProperty('--nav-height', `${this.$nav.offsetHeight}px`);
      if(this.hasAttribute('overlap')) {
        const mainContent = document.getElementById('MainContent');
        const firstSection = mainContent.firstElementChild;
        const overlapElement = firstSection.querySelector('[data-main-header-overlap]');
        if(overlapElement) {
          overlapElement.classList.add('@main-header-overlap');
          this.classList.add('@overlap');
        } else {
          this.classList.remove('@overlap');
        }
      }
    };
  });
})();